import { render } from "./Projekte.vue?vue&type=template&id=4aa48894&scoped=true"
import script from "./Projekte.vue?vue&type=script&lang=js"
export * from "./Projekte.vue?vue&type=script&lang=js"

import "./Projekte.vue?vue&type=style&index=0&id=4aa48894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa48894"]])

export default __exports__